import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DateTimeWithZone } from "../../../common/date-time-with-zone.class";

@Component({
  selector: 'app-operatives-leave-confirm',
  templateUrl: './operatives-leave-confirm.component.html',
  styleUrls: ['./operatives-leave-confirm.component.scss']
})

export class OperativesLeaveConfirmComponent implements OnInit {
  @Input() heading: string = "Confirm removal of Operative/s";
  @Input() endDateForOperatives: DateTimeWithZone = new DateTimeWithZone();
  @Output() removeOperativesRequested: EventEmitter<string> = new EventEmitter<string>();

  submitted: boolean = false;

  constructor(private modalRef: DynamicDialogRef) { }

  ngOnInit(): void {
  }

  cancelClicked() {
    this.modalRef.close();
    this.removeOperativesRequested.emit(null);
  }

  removeOperativesClicked() {
    this.submitted = true;
    if (!this.endDateForOperatives.dateTime)
      return;
    this.removeOperativesRequested.emit(this.endDateForOperatives.dateTime);
    this.modalRef.close();
  }
}
